import React, { Fragment } from 'react'
import Icon from 'assets/icons/Icon'
import theme from 'theme'

const addIconToLineOfText = (lineOfText) => {
  const keywords = {
    fullScreen: ['expand', 'full screen', 'розгорнути', 'весь екран'],
    headphones: ['headphones', 'навушники'],
    navigation: ['navigation', 'навігація'],
  }
  const lineIncludes = (keywords) => keywords.some((keyword) => lineOfText.toLowerCase().includes(keyword))
  const iconProps = { fill: theme.gray }
  if (lineIncludes(keywords.fullScreen)) {
    return <Icon name="fullscreen" width={23} height={22} className="instruction" {...iconProps} />
  } else if (lineIncludes(keywords.headphones)) {
    return <Icon name="headphones" width={24} height={24} className="instruction" {...iconProps} />
  } else if (lineIncludes(keywords.navigation)) {
    return <Icon name="plus" width={23} height={23} className="instruction" stroke={theme.gray} {...iconProps} />
  }
  return null
}

const InstructionMode = ({ close, t }) => {
  return (
    <Fragment>
      <div
        style={{
          maxWidth: 'calc(40.34vw + 80px)',
          perspective: '2000px',
          position: 'absolute',
          left: 'calc(18.75% - 40px)',
          top: 'calc(6.66% - 20px)',
          overflowY: 'scroll',
          overflowX: 'hidden',
          bottom: 0,
          padding: '20px 40px',
        }}
      >
        <Icon name="cross" width={30} height={30} stroke={theme.white} className="crossInstruction" onClick={close} />
        <div style={{ transform: 'rotateY(-20deg)', fontSize: '24px', lineHeight: '150%' }}>
          {t('guidance')
            .split('\n\n')
            .map((paragraph, index) => {
              return (
                <div key={index + new Date().getTime()} style={{ marginBottom: '20px' }}>
                  {paragraph.split('\n').map((newLine, index) => {
                    return (
                      <div key={index + new Date().getTime()} style={{ display: 'flex', alignItems: 'center' }}>
                        {addIconToLineOfText(newLine)}
                        <div>{newLine}</div>
                      </div>
                    )
                  })}
                </div>
              )
            })}
        </div>
      </div>
    </Fragment>
  )
}

export default InstructionMode
